module.exports = __webpack_public_path__ + "static/media/partneri.17e19c60.sass";


//////////////////
// WEBPACK FOOTER
// ./src/components/89/partneri.sass
// module id = 1330
// module chunks = 0